import * as React from 'react';
import { Image } from '@cian/ui-kit';
import { TBorderRadius } from '../../containers/CardImage/types';

interface ICardImageProps {
  src: string;
  width?: string;
  height: string;
  borderRadius: TBorderRadius;
}

/* istanbul ignore next */
export function CardImage({ width, height, src, borderRadius }: ICardImageProps) {
  return <Image src={src} width={width} height={height} borderRadius={borderRadius} objectFit="cover" />;
}
